import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

export interface UpdateRequest {
    list_no: string;
    c_name: string;
    c_charge_name: string;
    c_dept_name: string;
    c_mobile: string;
    kind: string;
    pay_gbn: string;
    doc: string;
    sfast: string;
    item_type: string;
    s_start: string;
    start_telno: string;
    dept_name: string;
    charge_name: string;
    start_sido: string;
    start_gugun: string;
    start_dong: string;
    start_location: string;
    s_dest: string;
    dest_telno: string;
    dest_dept: string;
    dest_charge: string;
    dest_sido: string;
    dest_gugun: string;
    dest_dong: string;
    dest_location: string;
    reason_desc: string;
    kind_etc: string;
    dtime: string;
}

export interface UpdateResponse {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

export const usePutConsoleExpressOrder = (
    successCallback?: (data: UpdateResponse) => void,
): UseMutationResult<UpdateResponse, Error, UpdateRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<UpdateResponse, Error, UpdateRequest>({
        mutationFn: async (updateData: UpdateRequest) => {
            const url = enum_api_uri.put_console_express_order.replace(":list_no", updateData.list_no);
            const response = await axiosInstance.put(url, updateData);
            return response.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleExpressOrderDetail"] });
            successCallback?.(data);
        },
    });
};
